import React, { useEffect } from 'react'
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import { Col, Container, Row } from 'react-bootstrap';
import ImageCard from '../../../Components/ImageCard/ImageCard';
import CenterStage from '../../../Components/CenterStage/CenterStage';
import ServiceCarousel from '../../../Components/ServiceCarousel/ServiceCarousel';
import imgStage from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/stage.jpg'
import imgDonationInsteadGift from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/DonationInsteadGift.jpg'
import imgFoundation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/HFFoundation.jpg'
import imgWeAreCommitted from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/WeAreCommitted.jpg'
import imgStudentRacing from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/StudentRacing.jpg'
import imgSumatra from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/Sumatra.jpg'
import imgOldAndYoung from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/OldAndYoung.jpg'
import imgOffRoad from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/OffRoad.jpg'
import imgValueBasedCooperation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/ValueBasedCooperation.jpg'
import imgDonation from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/Donation.jpg'
import imgBecomeAPart from '../../../assets/ResponsibilityAndSocialCommitments/ResponsibilyAndSocial/BecomeAPart.jpg'

const ResponsibilityAndSocialCommitments = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const data1 = {
        image: imgDonationInsteadGift,
        title: 'Donations instead of gifts',
        description: 'As part of our Christmas campaign "Donate instead of giving", we have been distributing a mid-five-figure sum each year to three selected aid organizations since 2017. The donations go to current projects to sustainably improve drinking water and sanitation supplies for people in the countries of the Global South. Through accompanying reporting in our customer and employee magazine Hydraulikpresse and our campaign website and by directly addressing customers and business partners, we increase the awareness of the organizations and their projects and encourage additional donations.',
    }

    const data2 = {
        image: imgFoundation,
        title: 'The HANSA‑FLEX Foundation',
        description: 'The HANSA‑FLEX Foundation was established in 2012 by company founder Joachim Armerding. It is committed to education and the promotion of young talent as well as intercultural exchange. Another purpose of the foundation is to promote the home city of Bremen as a location for science, research and training. The HANSA‑FLEX Foundation is a member of university sponsorship and support groups, supports scholarship holders and maintains endowed professorships at various faculties. In addition, it supports a wide range of cultural and educational projects and local initiatives.',
    }

    const data3 = {
        image: imgWeAreCommitted,
        title: 'We are committed to people in motion',
        description: "Sport promotes health and well-being and strengthens solidarity. That is why HANSA‑FLEX supports clubs, teams and individual athletes at many locations. The international HANSA‑FLEX club sponsorship is our largest regular activity for the youth sector. Since 2002, we have equipped a total of 30 children's and youth teams with new sportswear every year. The high-quality team equipment, each worth 1,000 euros, benefits teams from a wide variety of sports at home and abroad. To mark our 60th anniversary, we will be sponsoring 60 youth teams in 2022 instead of 30.",
    }

    const ServiceCarouselData = [
        {
            title: "Student Racing Team",
            description: "HANSA‑FLEX is one of the sponsors of Deefholt Dynamics eV. The multidisciplinary team of students from the Private University of Applied Sciences for Economics and Technology (PHWT) in Diepholz regularly takes part in the major international Formula Student design competitions.",
            imageSrc: imgStudentRacing
        },
        {
            title: "Help with Reconstruction in Sumatra",
            description: "The village of Suak Nie in the province of Aceh in the north of the island of Sumatra was hit particularly hard by the tsunami catastrophe in Southeast Asia in the early 2000s. Since then , HANSA‑FLEX has been supporting the villagers in building new livelihoods in a sustainable manner in cooperation with terre des hommes.",
            imageSrc: imgSumatra
        },
        {
            title: "Old and young-timer meeting",
            description: "The HANSA‑FLEX Motor Classic is a very special team event. In late summer, young and classic car fans from the circle of colleagues meet for an atmospheric motorsport weekend. The classic car rally takes place at different locations in attractive agricultural surroundings.",
            imageSrc: imgOldAndYoung
        },
        {
            title: "Internationales Offroad-Abenteuer",
            description: "Unter dem Namen XWORLD hat HANSA‑FLEX bislang drei außergewöhnliche Offroad-Abenteuerreisen durch Europa/Asien, Südamerika und Afrika veranstaltet. Dabei haben die Teilnehmerinnen und Teilnehmer insgesamt 58 Länder durchquert und über 150.000 Kilometer Fahrstrecke zurückgelegt.",
            imageSrc: imgOffRoad
        }
    ];

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"WE KNOW OUR RESPONSIBILITY"}
                paragraph={"For HANSA‑FLEX, as an owner-managed family business, social commitment to people and society has always played a major role. In addition to supporting charitable institutions and projects, the areas of sport, education and intercultural exchange are also promoted."} />

            <SectionHeader title={"COMMITMENT TO PEOPLE AND THEIR NEEDS"} />
            <ImageText data={data1} left={true} />
            <ImageText data={data2} left={false} />
            <ImageText data={data3} left={true} />

            <SectionHeader title={"WE STRENGTHEN COMMUNITIES AND PROMOTE PASSIONS"}
                subtitle={"HANSA‑FLEX is committed to helping and connecting people, strengthening communities and supporting passions at many locations."} />
            <ServiceCarousel images={ServiceCarouselData} autoPlayInterval={5000} />

            <SectionHeader
                title={"FIND OUT MORE ABOUT HANSA-FLEX'S CULTURE AND VALUES"}
            />
            <div>
                <Container className="custom-container">
                    <Row>
                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgValueBasedCooperation}
                            title="Value-based cooperation"
                            desc={"HANSA‑FLEX stands for fairness, respect and transparency. Our Mission Statement and Code of Conduct apply at all locations worldwide."}
                            learnMoreLink={"/hansa-flex-group/mission-statement-and-values"} /></Col>

                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgDonation}
                            title="Donations instead of gifts"
                            desc={"Get to know all the projects we have supported since 2017 as part of our annual Christmas campaign."}
                            learnMoreLink={"/services/production/series-production"} /></Col>

                        <Col sm={12} md={6} lg={4} ><ImageCard image={imgBecomeAPart}
                            title="Become part of the team"
                            desc={"We are looking for new colleagues with a passion for their work and great expertise in their fields for various commercial and technical positions at several locations."}
                            learnMoreLink={"/services/logistics-solutions/hydraulic-workshop-containers"} /></Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}

export default ResponsibilityAndSocialCommitments   